var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:round-favorite"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3497 20.1297C12.5897 20.8197 11.4197 20.8197 10.6597 20.1197L10.5497 20.0197C5.29967 15.2697 1.86966 12.1597 1.99966 8.27968C2.05966 6.57968 2.92966 4.94968 4.33966 3.98968C6.97966 2.18968 10.2397 3.02968 11.9997 5.08968C13.7597 3.02968 17.0197 2.17968 19.6597 3.98968C21.0697 4.94968 21.9397 6.57968 21.9997 8.27968C22.1397 12.1597 18.6997 15.2697 13.4497 20.0397L13.3497 20.1297Z",
    fill: "#FF0A38"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.f3814d963cd0331873d027816f0b8886.svg";
export { ForwardRef as ReactComponent };